import { createRoute } from '@tanstack/react-router';
import ContractsPage from '@/features/dashboard/acceptedConsents/pages/ContractsPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const contractsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/contracts',
  component: ContractsPage,
  validateSearch: listSearchSchema,
});
